import {
  GET_PUBLIC_PROJECTS,
  GET_PRIVATE_PROJECTS,
  TOGGLE_PROJECT,
} from "../actions/types";

const initialState = {
  all_public_projects: [],
  all_private_projects: [],
  project_loading: false,
};

export default function projectReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PUBLIC_PROJECTS:
      return { ...state, all_public_projects: action.payload };
    case GET_PRIVATE_PROJECTS:
      return { ...state, all_private_projects: action.payload };
    case TOGGLE_PROJECT:
      return { ...state, project_loading: !state.project_loading };
    default:
      return state;
  }
}
